// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GNap","colBig":"styles_colBig__3Ahfp","colSmall":"styles_colSmall__izHpc","shopifyNameWrapper":"styles_shopifyNameWrapper__FMi5X"};